import React from 'react';
import styles from './ActionButtons.module.scss';
import { T } from '@colonist/ui';
import { UIGameButton } from '../../../../common/UIGameButton/index.ts';
import IconShare from '@static/images/icon_share.svg';
import { useUIGameEndContext } from '../../../../contexts/UIGameEndContext.tsx';
import { useGameStore } from '../../../../store/GameStoreContext.ts';
export function ShareButton() {
    const { onClickShare } = useUIGameEndContext();
    const isSharingEnabled = useGameStore((state)=>state.gameEnd.isSharingEnabled);
    const gameEndShareIcon = useGameStore((state)=>state.gameEnd.gameEndShareIcon);
    if (!isSharingEnabled) return null;
    return /*#__PURE__*/ React.createElement(UIGameButton, {
        className: styles.button,
        onClick: onClickShare
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.endGame.cornerButton.share'
        }
    }), /*#__PURE__*/ React.createElement("img", {
        className: styles.icon,
        src: gameEndShareIcon !== null && gameEndShareIcon !== void 0 ? gameEndShareIcon : IconShare
    }));
}
